import React, { Component, PropTypes } from 'react';
import ButtonDefault from '../button-default/ButtonDefault.jsx';

export default class ButtonContinue extends Component {
	static propTypes = {
		handleContinueProp: PropTypes.func.isRequired,
		buttonText: PropTypes.string,
		decoratorClass: PropTypes.string,
		buttonState: PropTypes.string,
		intl: PropTypes.object, // GG.FrontEnd.DNA.react.intl
		isDisabled: PropTypes.bool,
		showDisabled: PropTypes.bool,
		qaSelector: PropTypes.string,
		continueButtonFootnote: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.object
		]),
		wrapperDecoratorClass: PropTypes.string,
		id: PropTypes.string,
		type: PropTypes.string,
		accessibleIsLoadingText: PropTypes.string
	};
	static defaultProps = {
		id: 'continue',
		type: 'submit'
	};
	getButtonText() {
		const { buttonText, intl } = this.props;
		return buttonText ? buttonText : intl.formatMessage('content|_defaults|continueLabel');
	}
	handleContinue(e) {
		e.preventDefault();
		const { buttonState, handleContinueProp } = this.props;
		if (buttonState === 'loading'){
			return;
		}
		handleContinueProp();
	}
	render() {
		const {
			id,
			type,
			intl,
			qaSelector,
			buttonState,
			isDisabled,
			showDisabled,
			decoratorClass,
			wrapperDecoratorClass,
			continueButtonFootnote,
			accessibleIsLoadingText
		} = this.props;

		const buttonText = ::this.getButtonText();

		return (
			<div className={`${wrapperDecoratorClass ? wrapperDecoratorClass : ''}`}>
				<ButtonDefault
					id={id}
					intl={intl}
					type={type}
					buttonState={buttonState}
					isDisabled={isDisabled}
					showDisabled={showDisabled}
					decoratorClass={`dna-button-brand ${decoratorClass ? decoratorClass : ''} ${continueButtonFootnote ? 'dna-space-mbm' : ''}`}
					qaSelector={qaSelector}
					accessibleIsLoadingText={accessibleIsLoadingText}
					handleClick={::this.handleContinue}>
					{ buttonText }
				</ButtonDefault>
				{ continueButtonFootnote && continueButtonFootnote }
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ../~/dna-button/components/button-continue/ButtonContinue.jsx